import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { getMe } from "@/modules/auth/api/auth";

type State = "loading" | "authenticated" | "unauthenticated";

export function AuthGuard() {
  const [state, setState] = useState<State>("loading");

  useEffect(() => {
    getMe()
      .then((user) => {
        Sentry.setUser({ email: user.email });
        setState("authenticated");
      })
      .catch(() => setState("unauthenticated"));
  }, []);

  if (state === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#e8ebf2]">
        <p className="text-[#6780a2] text-lg">Loading...</p>
      </div>
    );
  }

  if (state === "unauthenticated") {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
